// extracted by mini-css-extract-plugin
module.exports = {"root":"DeliveryModalContainer_root__2ritZ","buttonGroup":"DeliveryModalContainer_buttonGroup__3YbmK","inputList":"DeliveryModalContainer_inputList__2Dsku"};